/* winterburn: music videos.
   - Plays a video inline when its card is clicked (falls back to opening YouTube).
   - With data-key set, loads the channel's latest uploads from the YouTube Data API
     and replaces the cards added in the theme editor. Results are cached for 3 hours
     in the visitor's browser so the API is called rarely. */
(function () {
  if (customElements.get('wb-videos')) return;

  var CACHE_MS = 3 * 60 * 60 * 1000;
  var API = 'https://www.googleapis.com/youtube/v3/';

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtDate(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    function p(n) { return (n < 10 ? '0' : '') + n; }
    return p(d.getUTCDate()) + '.' + p(d.getUTCMonth() + 1) + '.' + d.getUTCFullYear();
  }
  function card(v, i, feat) {
    var num = (i < 10 ? '0' : '') + i;
    var thumb = feat ? 'maxresdefault' : 'hqdefault';
    return '<a class="wb-vid' + (feat ? ' wb-vid--feat' : '') + '" href="https://www.youtube.com/watch?v=' + esc(v.id) +
      '" target="_blank" rel="noopener" data-yt="' + esc(v.id) + '" data-title="' + esc(v.title) + '">' +
      '<div class="wb-vid__m"><img src="https://i.ytimg.com/vi/' + esc(v.id) + '/' + thumb + '.jpg" alt="" loading="lazy" width="1280" height="720"' +
      ' onerror="if(this.src.indexOf(\'hqdefault\')<0){this.src=\'https://i.ytimg.com/vi/' + esc(v.id) + '/hqdefault.jpg\'}">' +
      '<span class="wb-vid__k"></span><span class="wb-vid__lab wb-mono">Fig. ' + num + ' · Music video</span>' +
      '<span class="wb-vid__play" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M7 4l13 8-13 8z"/></svg></span></div>' +
      '<div class="wb-vid__cap"><h3>' + esc(v.title) + '</h3><span class="wb-meta">' + esc(v.date) + '</span></div></a>';
  }
  function iso8601ToSec(s) {
    var m = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/.exec(s || '');
    return m ? (+(m[1] || 0)) * 3600 + (+(m[2] || 0)) * 60 + (+(m[3] || 0)) : 0;
  }

  var ytState = 0, ytQueue = [];
  function loadYT(ok, fail) {
    if (window.YT && window.YT.Player) { if (ok) ok(); return; }
    if (ok) ytQueue.push(ok);
    if (ytState) return;
    ytState = 1;
    var prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () { if (prev) prev(); var q = ytQueue; ytQueue = []; q.forEach(function (f) { f(); }); };
    var sc = document.createElement('script');
    sc.src = 'https://www.youtube.com/iframe_api';
    sc.async = true;
    sc.onerror = function () { ytState = 0; var q = ytQueue; ytQueue = []; if (fail && q.length) fail(); };
    document.head.appendChild(sc);
  }

  class WbVideos extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
      var self = this;
      var warm = function () { loadYT(); };
      ['pointerover', 'touchstart', 'focusin'].forEach(function (t) { this.addEventListener(t, warm, { once: true, passive: true }); }, this);
      // With a mouse, place the real YouTube player (invisible) over the card on hover, so the
      // click lands on YouTube itself. Safari only allows sound when the click is inside the player.
      this.addEventListener('pointerover', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        var v = e.target.closest && e.target.closest('.wb-vid[data-yt]');
        if (v) self.arm(v);
      });
      window.addEventListener('blur', function () {
        setTimeout(function () {
          var a = document.activeElement;
          if (a && a.classList && a.classList.contains('wb-vid__arm') && self.contains(a)) self.reveal(a);
        }, 0);
      });
      // Touch screens (iPhone etc.): there is no hover, so place the invisible player over each
      // video as it scrolls into view. The tap then lands on YouTube and plays straight away.
      if (window.matchMedia && matchMedia('(hover: none)').matches && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (en.isIntersecting) { self.io.unobserve(en.target); self.arm(en.target); } });
        }, { rootMargin: '150px 0px' });
        this.watch();
      }
      var key = (this.dataset.key || '').trim();
      var channel = (this.dataset.channel || '').trim();
      if (key && /^UC[\w-]{22}$/.test(channel)) this.load(key, channel);
    }

    arm(v) {
      var m = v.querySelector('.wb-vid__m');
      if (!m || m.querySelector('iframe') || m.querySelector('.wb-vid__yt')) return;
      var f = document.createElement('iframe');
      f.className = 'wb-vid__arm';
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(v.dataset.yt) + '?enablejsapi=1&rel=0&modestbranding=1&playsinline=1&origin=' + encodeURIComponent(location.origin);
      f.title = v.dataset.title || 'Music video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      m.appendChild(f);
      var self = this;
      loadYT(function () {
        f._p = new YT.Player(f, { events: { onStateChange: function (ev) { if (ev.data === 1 || ev.data === 3) self.reveal(f); } } });
      });
    }

    watch() {
      if (!this.io) return;
      var io = this.io;
      this.querySelectorAll('.wb-vid[data-yt]').forEach(function (v) { io.observe(v); });
    }

    reveal(f) { f.classList.remove('wb-vid__arm'); }

    onClick(e) {
      var v = e.target.closest('.wb-vid[data-yt]');
      if (!v) return;
      var m = v.querySelector('.wb-vid__m');
      e.preventDefault();
      var armed = m.querySelector('iframe.wb-vid__arm');
      if (armed) { this.reveal(armed); try { armed._p && armed._p.playVideo(); } catch (x) {} return; }
      if (m.querySelector('iframe') || m.querySelector('.wb-vid__yt')) return;
      var id = v.dataset.yt, title = v.dataset.title || 'Music video';
      // Touch screens: use the YouTube player API and call playVideo() when it is ready.
      if (window.YT && window.YT.Player) return this.player(m, id, title);
      var self = this;
      loadYT(function () { self.player(m, id, title); }, function () { self.plain(m, id, title); });
    }

    player(m, id, title) {
      var box = document.createElement('div');
      box.className = 'wb-vid__yt';
      m.appendChild(box);
      new YT.Player(box, {
        host: 'https://www.youtube-nocookie.com',
        videoId: id,
        playerVars: { autoplay: 1, playsinline: 1, rel: 0, modestbranding: 1 },
        events: {
          onReady: function (ev) { var f = ev.target.getIframe(); f.title = title; f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen'); ev.target.playVideo(); }
        }
      });
    }

    plain(m, id, title) {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      f.title = title;
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      m.appendChild(f);
    }

    async load(key, channel) {
      var count = Math.max(1, Math.min(12, parseInt(this.dataset.count || '4', 10)));
      var filter = this.dataset.filter || '';
      var strip = this.dataset.strip === 'true';
      var skipVertical = this.dataset.skipVertical === 'true';
      var cacheKey = 'wb-yt:' + [channel, count, filter, strip, skipVertical, 'd3'].join('|');

      try {
        var cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
        if (cached && Date.now() - cached.t < CACHE_MS && cached.v.length) { this.render(cached.v); return; }
      } catch (err) {}

      try {
        var uploads = 'UU' + channel.slice(2);
        var pl = await fetch(API + 'playlistItems?part=snippet,contentDetails&maxResults=50&playlistId=' + uploads + '&key=' + encodeURIComponent(key)).then(function (r) { return r.json(); });
        if (!pl.items) throw new Error((pl.error && pl.error.message) || 'No uploads');
        var items = pl.items
          .filter(function (it) { return it.snippet && it.snippet.title !== 'Private video' && it.snippet.title !== 'Deleted video'; })
          .filter(function (it) { return !filter || it.snippet.title.toLowerCase().indexOf(filter.toLowerCase()) === 0; });
        if (!items.length) throw new Error('No matching uploads');

        var ids = items.map(function (it) { return it.contentDetails.videoId; }).slice(0, 50);
        var det = await fetch(API + 'videos?part=contentDetails,player,status&maxWidth=640&id=' + ids.join(',') + '&key=' + encodeURIComponent(key)).then(function (r) { return r.json(); });
        var info = {};
        (det.items || []).forEach(function (v) { info[v.id] = v; });

        var list = [], days = {};
        items.forEach(function (it) { var k = (it.contentDetails.videoPublishedAt || it.snippet.publishedAt || '').slice(0, 10); days[k] = (days[k] || 0) + 1; });
        for (var i = 0; i < items.length && list.length < count; i++) {
          var it = items[i], id = it.contentDetails.videoId, d = info[id];
          if (!d || (d.status && d.status.embeddable === false) || (d.status && d.status.privacyStatus !== 'public')) continue;
          if (skipVertical && d.player && +d.player.embedHeight > +d.player.embedWidth) continue;
          if (skipVertical && iso8601ToSec(d.contentDetails && d.contentDetails.duration) <= 60) continue;
          /* skip batch uploads (several on one day share the same cover) */
          var day = (it.contentDetails.videoPublishedAt || it.snippet.publishedAt || '').slice(0, 10);
          if (day && days[day] > 1) continue;
          var title = it.snippet.title;
          if (strip && filter && title.toLowerCase().indexOf(filter.toLowerCase()) === 0) title = title.slice(filter.length);
          list.push({ id: id, title: title.replace(/\s*[(\[]official (music )?video[)\]]/i, '').trim(), date: fmtDate(it.contentDetails.videoPublishedAt || it.snippet.publishedAt) });
        }
        if (!list.length) throw new Error('Nothing to show');
        try { localStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), v: list })); } catch (err) {}
        this.render(list);
      } catch (err) {
        if (window.Shopify && window.Shopify.designMode) console.warn('[winterburn] YouTube videos:', err.message);
        /* keep the videos added in the theme editor */
      }
    }

    render(list) {
      var html = card(list[0], 1, true);
      if (list.length > 1) {
        html += '<div class="wb-vrow">';
        for (var i = 1; i < list.length; i++) html += card(list[i], i + 1, false);
        html += '</div>';
      }
      this.innerHTML = html;
      this.classList.add('is-live');
      this.watch();
    }
  }

  customElements.define('wb-videos', WbVideos);
})();
